import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { IMintTraitItem } from '@/pages/XDao/ProjectsPage/components/SidebarMintTrait';

type State = {
    isOpenWalletManagement: boolean;
    isOpenDaoSidebar: boolean;
    isOpenUpgradeSidebar: boolean;
    selectedMintTraits: IMintTraitItem[];
}

type Action = {
    setIsOpenWalletManagement: (isOpen: boolean) => void;
    setIsOpenDaoSidebar: (isOpen: boolean) => void;
    setIsOpenUpgradeSidebar: (isOpen: boolean) => void;
    addMintTrait: (item: IMintTraitItem) => void;
    removeMintTrait: (traitId: number) => void;
    clearMintTraits: () => void;
    setSelectedMintTraits: (items: IMintTraitItem[]) => void;
}

const useSidebarStore = create<State & Action>()(
    immer((set) => ({
        isOpenWalletManagement: false,
        setIsOpenWalletManagement: (isOpen) => set({ isOpenWalletManagement: isOpen }),
        isOpenDaoSidebar: false,
        setIsOpenDaoSidebar: (isOpen) => set({ isOpenDaoSidebar: isOpen }),
        isOpenUpgradeSidebar: false,
        setIsOpenUpgradeSidebar: (isOpen) => set({ isOpenUpgradeSidebar: isOpen }),
        selectedMintTraits: [],
        addMintTrait: (item) => set((state) => {
            // Only add if not already in the cart
            const exists = state.selectedMintTraits.some(trait => trait.id === item.id);
            if (!exists) {
                state.selectedMintTraits.push(item);
            }
        }),
        removeMintTrait: (traitId) => set((state) => {
            state.selectedMintTraits = state.selectedMintTraits.filter(trait => trait.id !== traitId);
        }),
        clearMintTraits: () => set({ selectedMintTraits: [] }),
        setSelectedMintTraits: (items) => set({ selectedMintTraits: items }),
    }))
);

export default useSidebarStore;